import startsWith from 'lodash/startsWith';

import { isMobile } from '~/genericFunctions';
import nls from './nls/SuccessPage';
import { createTranslator } from '~/lib/nls-helper';

export const NLS = createTranslator(nls);

export const isHeaderVisible = (ismobile) => isMobile(ismobile);

export const isButtonVisible = (ismobile) => !isMobile(ismobile);

export const getDiHeaderKey = (offerId) => {
  if (['LC_Recom_Rev_Premier_BPI', 'Refill_Nom_Mob'].includes(offerId))
    return 'Proof of operation of the hiring and disposition of HSBC Payroll Credit';
  else if (['LC_Recom_Rev_Adva_BPI', 'Sub_Rev_OH', 'Refill_CP_Mob'].includes(offerId))
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit';
  else {
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit or HSBC Payroll Credit';
  }
};

export const getTopUpHeaderKey = (offerId) => {
  if (['TopUp_AN_MB', 'TopUp_AN_Mob', 'TopUp_KR_PIB_AN', 'TopUp_KR_MOB_AN'].includes(offerId))
    return 'Proof of operation of the hiring and disposition of HSBC Payroll Credit';
  else if (['Nva_TopUp_CP', 'TopUp_CP_MB', 'TopUp_CP_Mob'].includes(offerId))
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit';
  else {
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit or HSBC Payroll Credit';
  }
};

export const getSimpleKronerHeaderKey = (offerId) => {
  if (startsWith(offerId, 'Simple_Nom') || offerId === 'Simple_MenoresAN_Mob')
    return 'Proof of operation of the hiring and disposition of HSBC Payroll Credit';
  else if (startsWith(offerId, 'Simple_CP') || offerId === 'Simple_MenoresCP_Mob')
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit';
  else {
    return 'Proof of operation of the hiring and disposition of HSBC Personal Credit or HSBC Payroll Credit';
  }
};
